import { LEGEND_MAX_ICON_COLOR } from '../constants';

const parseMaximumLegend = maximumLegend => {
  if (maximumLegend.hasOwnProperty('value')) {
    return {
      value: maximumLegend.value,
      label: maximumLegend.label,
      color: LEGEND_MAX_ICON_COLOR,
    };
  }
  return maximumLegend;
};

export default parseMaximumLegend;
